import SimpleTooltip from '@rio-cloud/rio-uikit/SimpleTooltip';
import Switch from '@rio-cloud/rio-uikit/components/switch/Switch';
import { FormattedMessage, useIntl } from 'react-intl';
import { useAppDispatch, useAppSelector } from '../../configuration/setup/hooks';
import {
    selectHasChargingStationAsWp,
    selectIsAutomatedPlanningMode,
    selectOrderedWaypoints,
} from '../../store/search/searchSelectors';
import { togglePlanningMode, type Waypoint, waypointRemoved, WaypointType } from '../../store/search/searchSlice';
import { NotificationType, showMapNotification } from '../../store/widget/actions/showMapNotification';

export const SwitchPlanningMode = () => {
    const intl = useIntl();
    const dispatch = useAppDispatch();

    const isAutomatedPlanningMode = useAppSelector(selectIsAutomatedPlanningMode);
    const hasChargingStationAsWp = useAppSelector(selectHasChargingStationAsWp);
    const orderedWaypoints = useAppSelector(selectOrderedWaypoints);

    const handleSwitchPlanningMode = () => {
        if (hasChargingStationAsWp && !isAutomatedPlanningMode) {
            orderedWaypoints.forEach((waypoint: Waypoint) => {
                if (waypoint.type === WaypointType.CHARGING_STATION) {
                    dispatch(waypointRemoved(waypoint.id));
                }
            });
            const message = intl.formatMessage({
                id: 'intl-msg:smartRoute.notification.chargingStationsRemoved',
            });
            const title = intl.formatMessage({
                id: 'intl-msg:smartRoute.notification.switchedPlanningMode',
            });
            showMapNotification(NotificationType.WARNING, message, title);
        }
        dispatch(togglePlanningMode(!isAutomatedPlanningMode));
    };

    return (
        <div
            className='margin-top-20 display-flex justify-content-between text-color-dark'
            data-testid='switch-plan-mode'
        >
            <span>
                <FormattedMessage id='intl-msg:smartRoute.tour.stopovers.mode.title' />
                <SimpleTooltip
                    content={<FormattedMessage id='intl-msg:smartRoute.notification.autoPlanMode.tooltip' />}
                    placement='bottom'
                >
                    <span
                        className='rioglyph rioglyph-question-sign margin-left-5
                                    text-size-12'
                    />
                </SimpleTooltip>
            </span>
            <Switch
                onChange={handleSwitchPlanningMode}
                checked={isAutomatedPlanningMode}
                minWidth={50}
                enabledText='ON'
                disabledText='OFF'
                labelPosition='left'
                data-testid='switch-mode'
            >
                <FormattedMessage id='intl-msg:smartRoute.tour.stopovers.mode.switch.title' />
            </Switch>
        </div>
    );
};
